// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../index';

import { gql } from 'graphql-tag';
import { AssetFragmentDoc } from '../../../fragments/asset.fragment.generated';
import { StoneShapeTranslationFragmentDoc } from './stoneShapeTranslation.fragment.generated';
export const StoneShapeFragmentDoc = gql`
    fragment stoneShape on StoneShape {
  systemCode
  icon {
    ...asset
  }
  samplePhoto {
    ...asset
  }
  translation(locale: $locale) {
    ...stoneShapeTranslation
  }
}
    ${AssetFragmentDoc}
${StoneShapeTranslationFragmentDoc}`;